var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.97132C0 3.15729 2.35155 0.882812 5.19599 0.882812C8.04845 0.882812 10.4 3.15729 10.4 5.97132C10.4 7.38935 9.88429 8.70583 9.03546 9.82166C8.09903 11.0525 6.94485 12.1249 5.6457 12.9666C5.34836 13.1612 5.08002 13.1759 4.75369 12.9666C3.44713 12.1249 2.29295 11.0525 1.36454 9.82166C0.515096 8.70583 0 7.38935 0 5.97132ZM3.483 6.12948C3.483 7.07218 4.25225 7.81362 5.19546 7.81362C6.13929 7.81362 6.91594 7.07218 6.91594 6.12948C6.91594 5.19412 6.13929 4.41659 5.19546 4.41659C4.25225 4.41659 3.483 5.19412 3.483 6.12948Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGps);
export default __webpack_public_path__ + "static/media/location-gps.1a3f12c71ec2b78ad08f0885a2d0379b.svg";
export { ForwardRef as ReactComponent };